export const FOLDER_NAME_MAX_LENGTH = 100;

export const FOLDER_NAME_ERROR =
  'Il nome cartella non può contenere caratteri speciali.';

export const FOLDER_NAME_LENGTH_ERROR = `Il nome cartella non può superare i ${FOLDER_NAME_MAX_LENGTH} caratteri.`;

const FOLDER_NAME_REGEX = /^[A-Za-z0-9àèéìòùÀÈÉÌÒÙáéíóúÁÉÍÓÚ\s/\\(),.\-_]+$/;

export function getFolderNameError(name) {
  if (!name.trim()) {
    return '';
  }
  if (name.trim().length > FOLDER_NAME_MAX_LENGTH) {
    return FOLDER_NAME_LENGTH_ERROR;
  }
  return FOLDER_NAME_REGEX.test(name) ? '' : FOLDER_NAME_ERROR;
}

export function isFolderNameValid(name) {
  return name.trim().length > 0 && !getFolderNameError(name);
}
